import {ButtonPrimary, ButtonSecondary, Input, ModalBase} from "pac-ux-components";
import React from "react";

function EditStoreModal(props) {
    const [saving, setSaving] = React.useState(false);
    const [store, setStore] = React.useState(props.store);

    return (<div>
        <ModalBase
            style={{display: (props.display === true) ? 'block' : 'none'}}
        >
            <form
                onSubmit={async (e) => {
                    e.preventDefault();
                    setSaving(true);
                    await props.handleSave(store);
                    e.stopPropagation();
                    return;
                }}
            >
                <div style={{width: '619px', height: '478px', paddingLeft: 33, fontFamily: 'Inter'}}>
                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 24,
                        fontWeight: '700',
                        marginTop: 38,
                        wordWrap: 'break-word'
                    }}>Edit Store
                    </div>
                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        marginTop: 10,
                        height: 54,
                        wordWrap: 'break-word'
                    }}>Edit the store detail
                    </div>
                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                    }}>Store Name
                    </div>
                    <Input value={store.name}
                           onChange={(e) => {
                               setStore({...store,  name: e.target.value});
                           }}
                           required={true}
                           style={{
                               background: 'white',
                               borderRadius: 2,
                               border: '1px #949494 solid',
                               width: 530,
                               height: 40,
                               margin: '8px 0px'
                           }}
                    />

                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 32,
                    }}>Store ID
                    </div>
                    <div style={{
                        width: '100%',
                        color: '#7A7A7A',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 8,
                    }}>{store.id}
                    </div>
                </div>

                <div style={{
                    float: 'right', marginBottom: 32, marginRight: 32,
                }}>

                    <ButtonSecondary
                        onClick={() => {
                            props.closeModal()
                        }}
                        style={{
                            marginRight: 32,
                        }}>Cancel</ButtonSecondary>

                    <ButtonPrimary
                        type='submit'
                        disabled={saving}
                    >Save</ButtonPrimary>
                </div>
            </form>
        </ModalBase>
    </div>);
}

export default EditStoreModal;